<template>
  <div class="location-block flex flex-col md:flex-row gap-8 items-start">
    <div class="w-full md:w-1/2">
      <div class="mt-4">
        <h2 class="text-4xl font-bold mb-4">{{ location.name }}</h2>
      </div>
      <address class="not-italic mb-4">
        <strong class="block mb-2">{{ location.facilityName }}</strong>
        <span class="block mb-2">{{ location.address.street }}</span>
        <span class="block">{{ location.address.city }}, {{ location.address.state }} {{ location.address.zip }}</span>
        <span v-if="location.phone" class="block mt-2">{{ location.phone }}</span>
      </address>
      <router-link 
        v-if="showScheduleLink"
        :to="`/${location.locationUrl}#schedule`"
        class="underline uppercase italic"
      >VIEW CLASS SCHEDULE</router-link>
    </div>
    <div class="w-full md:w-1/2 relative overflow-hidden">
      <div class="aspect-video w-full">
        <iframe 
          :src="location.mapUrl" 
          class="w-full h-full absolute inset-0" 
          style="border:0;" 
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade" 
          :title="`Map to Empire Training Grounds in ${location.address.city}`">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingGround',
  props: {
    location: {
      type: Object,
      required: true,
      validator(value) {
        return [
          'name',
          'facilityName',
          'address',
          'mapUrl',
          'locationUrl'
        ].every(prop => prop in value)
      }
    },
    showScheduleLink: {
      type: Boolean,
      default: false
    }
  }
}
</script> 